<!--
Author: TangChen
Date: 2019-10-23
Desc: 基本信息
 -->
<template>
    <div :class="'view-upload-file view bg-white' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <div class="investor-data-up">
            <el-alert
                v-if="!isIE9"
                title="注意：上传的文件大小每张不能超过1.5M，格式类型只支持jpg，jpeg，png，pdf。"
                type="warning"
                show-icon
                :closable="false"
            />
            <div v-if="isIE9" class="cant-up">
                <el-alert
                    title="为保证上传证件质量，暂不支持IE9浏览器上传认证证件照，推荐使用谷歌、火狐或ie10以上浏览器进行上传认证。"
                    type="warning"
                    class="cant-info"
                    :closable="false"
                />
                <el-button type="yellow" class="medium" v-on:click="$router.push({name:'login'})">
                    确定
                </el-button>
            </div>
        </div>
        <div v-if="!isIE9" class="upload-form">
            <el-form
                ref="uploadInfo"
                :model="uploadInfo"
                :rules="rules"
                label-width="10px"
                class="uploadInfo"
                v-on:submit.native.prevent
            >
                <el-form-item label="" prop="transcert">
                    <div class="btn-all">
                        <input class="file" name="transcert" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['transcert'] }}</span>
                        <span class="text grey">经办人证件（二代身份证需要正反面复印件，加盖公章）<span v-html="fileText('transcert')"></span></span>
                        <br /><img v-if="imgBase64['transcert']" :src="imgBase64['transcert']">
                    </div>
                </el-form-item>
                <el-form-item label="" prop="accountapp">
                    <div class="btn-all">
                        <input class="file" name="accountapp" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['accountapp'] }}</span>
                        <span class="text grey">账户业务申请表（经办人签章、加盖公章、法人章）<span v-html="fileText('accountapp')"></span></span>
                        <br /><img v-if="imgBase64['accountapp']" :src="imgBase64['accountapp']">
                    </div>
                </el-form-item>
                <el-form-item label="" prop="authorization">
                    <div class="btn-all">
                        <input class="file" name="authorization" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['authorization'] }}</span>
                        <span class="text grey">授权委托书（加盖公章、法人章）<span v-html="fileText('authorization')"></span></span>
                        <br /><img v-if="imgBase64['authorization']" :src="imgBase64['authorization']">
                    </div>
                </el-form-item>
                <el-form-item label="" prop="beneficiary">
                    <div class="btn-all">
                        <input class="file" name="beneficiary" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['beneficiary'] }}</span>
                        <span class="text grey">受益人信息（加盖公章）<span v-html="fileText('beneficiary')"></span></span>
                        <br /><img v-if="imgBase64['beneficiary']" :src="imgBase64['beneficiary']">
                    </div>
                </el-form-item>
                <el-form-item v-if="info.existbenef==='0'" label="" prop="truebeneficiary">
                    <div class="btn-all">
                        <input class="file" name="truebeneficiary" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['truebeneficiary'] }}</span>
                        <span class="text grey">实际受益人证件（二代身份证需要正反面复印件，加盖公章）<span v-html="fileText('truebeneficiary')"></span></span>
                        <br /><img v-if="imgBase64['truebeneficiary']" :src="imgBase64['truebeneficiary']">
                    </div>
                </el-form-item>
                <el-form-item label="" prop="corporation">
                    <div class="btn-all">
                        <input class="file" name="corporation" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['corporation'] }}</span>
                        <span class="text grey">法人证件（二代身份证需要正反面复印件，加盖公章）<span v-html="fileText('corporation')"></span></span>
                        <br /><img v-if="imgBase64['corporation']" :src="imgBase64['corporation']">
                    </div>
                </el-form-item>
                <el-form-item v-if="checkMajor" label="" prop="controller">
                    <div class="btn-all">
                        <input class="file" name="controller" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['controller'] }}</span>
                        <span class="text grey">控制人证件（二代身份证需要正反面复印件，加盖公章）<span v-html="fileText('controller')"></span></span>
                        <br /><img v-if="imgBase64['controller']" :src="imgBase64['controller']">
                    </div>
                </el-form-item>
                <el-form-item label="" prop="bankaccount">
                    <div class="btn-all">
                        <input class="file" name="bankaccount" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['bankaccount'] }}</span>
                        <span class="text grey">银行账户证明（加盖公章）<span v-html="fileText('bankaccount')"></span></span>
                        <br /><img v-if="imgBase64['bankaccount']" :src="imgBase64['bankaccount']">
                    </div>
                </el-form-item>
                <el-form-item label="" prop="jfittreaty">
                    <div class="btn-all">
                        <input class="file" name="jfittreaty" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['jfittreaty'] }}</span>
                        <span class="text grey">网上交易协议（加盖公章）<span v-html="fileText('jfittreaty')"></span></span>
                        <br /><img v-if="imgBase64['jfittreaty']" :src="imgBase64['jfittreaty']">
                    </div>
                </el-form-item>
                <el-form-item v-if="info.certificatetype&&info.certificatetype!=='1'" label="" prop="othercert">
                    <div class="btn-all">
                        <input class="file" name="othercert" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['othercert'] }}</span>
                        <span class="text grey">{{ $cache.getDict(info.invtp==='0'?"130008":"120095",info.certificatetype) }}（加盖公章）<span v-html="fileText('othercert')"></span></span>
                        <br /><img v-if="imgBase64['othercert']" :src="imgBase64['othercert']">
                    </div>
                </el-form-item>
                <el-form-item v-if="info.certificatetype==='1'" label="" prop="businesslicense">
                    <div class="btn-all">
                        <input class="file" name="businesslicense" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['businesslicense'] }}</span>
                        <span class="text grey">企业法人营业执照（加盖公章）<span v-html="fileText('businesslicense')"></span></span>
                        <br /><img v-if="imgBase64['businesslicense']" :src="imgBase64['businesslicense']">
                    </div>
                </el-form-item>
                <el-form-item v-if="info.taxregistrationcert&&info.taxregistrationcert.trim()" label="" prop="etrccert">
                    <div class="btn-all">
                        <input class="file" name="etrccert" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['etrccert'] }}</span>
                        <span class="text grey">企业税务登记证（加盖公章）<span v-html="fileText('etrccert')"></span></span>
                        <br /><img v-if="imgBase64['etrccert']" :src="imgBase64['etrccert']">
                    </div>
                </el-form-item>
                <el-form-item v-if="info.organization&&info.organization.trim()" label="" prop="organizacode">
                    <div class="btn-all">
                        <input class="file" name="organizacode" type="file" accept="image/png,image/jpg,image/jpeg,application/pdf" v-on:change="getFile($event)" />
                        <span class="btn main b-main">{{ ocrBtnText['organizacode'] }}</span>
                        <span class="text grey">组织机构代码证（加盖公章）<span v-html="fileText('organizacode')"></span></span>
                        <br /><img v-if="imgBase64['organizacode']" :src="imgBase64['organizacode']">
                    </div>
                </el-form-item>

                <el-form-item class="margin-top">
                    <el-button type="yellow" class="medium" v-on:click.prevent="submitForm('uploadInfo')">
                        提交
                    </el-button>
                    <!--<el-button class="medium" type="back" v-on:click.prevent="$router.back()">
                        上一步
                    </el-button>-->
                </el-form-item>
            </el-form>
        </div>
        <!--内容-->
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import navBar from "@/components/common/navBar.vue";
export default {
    name: "ViewUploadFile",
    components: {
        navBar
    },
    mixins: [mixin],
    data () {
        return {
            isIE9: false,
            navs: [
                {id: "1",val: "经办人信息"},
                {id: "2",val: "基本信息"},
                {id: "3",val: "信息登记"},
                {id: "4",val: "银行信息"},
                {id: "5",val: "文件上传",active: "1"},
                {id: "6",val: "完成注册",icon: "fa fa-check"}
            ],
            ocrBtnText: {},
            defaultText: {
                othercert: "",
                transcert: "上传经办人证件",
                etrccert: "上传税务登记证",
                organizacode: "上传组织机构代码证",
                businesslicense: "上传营业执照",
                accountapp: "上传账户申请表",
                authorization: "上传授权委托书",
                jfittreaty: "上传网上交易协议",
                beneficiary: "上传受益人信息",
                truebeneficiary: "上传受益人证件",
                corporation: "上传法人证件",
                controller: "上传控制人证件",
                bankaccount: "上传银行账户证明"
            },
            fileName: {},
            uploadInfo: {
                othercert: "",
                transcert: "",
                etrccert: "",
                organizacode: "",
                businesslicense: "",
                accountapp: "",
                authorization: "",
                jfittreaty: "",
                beneficiary: "",
                truebeneficiary: "",
                corporation: "",
                controller: "",
                bankaccount: ""
            },
            // 临时存放上传文件文件名
            uploadName: {},
            file: {},
            rules: {
                transcert: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                etrccert: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                organizacode: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                businesslicense: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                accountapp: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                authorization: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                jfittreaty: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                beneficiary: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                truebeneficiary: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                corporation: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                controller: [
                    { validator: this.checkFile, trigger: "change" }
                ],
                bankaccount: [
                    { validator: this.checkFile, trigger: "change" }
                ]
            },
            info: {},
            needfileflag: "",
            refusetype: "",
            uploadForm: null,
            imgBase64: {}
        };
    },
    computed: {
        checkMajor(){
            const info = this.info;
            if((info.isControler && info.isControler !== "2") ||
                this.$util.isEmpty(info.majoritystakename) || (info.instreprname === info.majoritystakename &&
                info.instrepridtype === info.mcertificatetype &&
                info.instrepridcode === info.mcertificateno &&
                info.instreprvailddate === info.holdingidvalidate)){
                return false;
            }else{
                return true;
            }
        }
    },
    mounted() {
        if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
            this.isIE9 = true;
        }else{
            this.uploadForm = new FormData();
        }
        this.fileName = Object.assign({},this.uploadInfo);
        if(this.$store.state.login.status && !this.$util.isEmpty(this.$cache.getUser().invtp)){
            // 资料未上传
            const info = this.$cache.getUser();
            this.needfileflag = info.needfileflag;
            this.refusetype = info.refusetype;
            if(info.needfileflag === "0"){
                this.initData(info);
            }else if(info.needfileflag === "1"){ // 驳回
                this.getHasInfo();
            }

        }else{
            this.initInfo();
        }

    },
    methods: {
        fileText(name){
            return this.fileName[name] ? ("，上传文件为<span class='main'>" + this.fileName[name] + "</span>") : "";
        },
        // 检查文件是否上传
        checkFile(rule, value, callback){
            if(!this.file[rule.field] || !this.file[[rule.field]].name){
                callback(new Error("请上传文件"));
            }else{
                callback();
            }
        },
        getHasInfo(){
            const _this = this;
            const _info = this.$cache.getUser();
            if(_info.refusetype === "2"){
                this.$util.request("orgopen/refuse/info").then(res=>{
                    if(res.data){
                        _this.initData(res.data[0]);
                    }
                });
            }else{
                const _x = JSON.parse(sessionStorage.getItem("refuse") || "{}");
                _this.initData(_x);
            }
        },
        initData(_info){
            const _this = this;
            if(_info.certificatetype && _info.certificatetype !== "1"){
                _this.defaultText.othercert = _this.$cache.getDict(_info.invtp === "0" ? "130008" : "120095",_info.certificatetype);
            }
            _this.ocrBtnText = Object.assign({},_this.defaultText);
            _this.info = _info;
            if(this.needfileflag === "1" && this.refusetype === "2"){
                _this.refreshInfo(_info);
            }
        },
        getFile(event) {
            const file = event.target.files[0];
            console.log(window.URL.createObjectURL(file));
            const name = event.target.name;
            console.log(name);
            let repeat = false;
            const _filelast = file.name.split(".").reverse()[0];
            if (!/(jpg|jpeg|png|pdf)$/.test(_filelast.toLowerCase())) {
                if(!file && this.fileName[name]){
                    this.fileName[name] = "";
                    this.file[name] = {};
                    this.uploadForm.delete(event.target.name);
                }
                this.$message.warning("暂不支持上传" + _filelast + "类型的文件");
                return false;
            }
            if (!file || file.size > 1024 * 1024 * 1.5) {
                if(!file && this.fileName[name]){
                    this.fileName[name] = "";
                    this.file[name] = {};
                    this.uploadForm.delete(event.target.name);
                }
                const _mes = !file ? "请上传文件" : "上传文件大小超过限制大小1.5M，不能上传";
                this.$message.warning(_mes);
                return;
            }
            const _fn = event.target.files[0].name || "";
            Object.keys(this.file).forEach(key=>{
                if(this.file[key].name === _fn){
                    repeat = true;
                    this.$message.warning("上传文件名重复，请重试！");
                    return;
                }
            });
            if(repeat)return;
            // 获取input里的文件
            this.file[name] = event.target.files[0];
            this.fileName[name] = _fn.length > 15 ? (_fn.substr(0,10) + "." + _fn.split(".")[1]) : _fn;
            const reader = new FileReader();
            // 转base64
            let _this = this;
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };
            try{
                this.uploadForm.delete(event.target.name);
            }catch (e) {
                console.log(e);
            }
            this.uploadForm.append(event.target.name, file);
            reader.readAsDataURL(file);
            this.$refs.uploadInfo.validateField(name);
        },
        submitForm(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.updateInfo();
                } else {
                    return false;
                }
            });
        },
        initInfo(){
            const _this = this;
            const _info = JSON.parse(sessionStorage.getItem("refuse") || "{}");
            if(_info.certificatetype && _info.certificatetype !== "1"){
                _this.defaultText.othercert = _this.$cache.getDict(_info.invtp === "0" ? "130008" : "120095",_info.certificatetype);
            }
            _this.ocrBtnText = Object.assign({},_this.defaultText);
            _this.info = _info;
        },
        // 单独文件更新需要调用开户接口
        refreshInfo(info){
            const _bankInfo = {
                exchangebankcode: info.exchangebankcode,
                depositacctname: info.depositacctname,
                depositacct: info.depositacct,
                bankname: info.bankname,
                channelid: info.channelid,
                channelname: this.$cache.getDict("150003",info.banksno),
                depositprov: info.depositprov,
                banksno: info.banksno,
                depositcity: info.depositcity,
                tpasswd: this.$util.enc("")
            };
            this.$util.request("orgopen/acct/submit",_bankInfo,"POST");
        },
        // 文件上传
        updateInfo(){
            const _this = this;
            _this.$req({
                method: "POST",
                // url: "org/open/stream",
                url:"org/open/base64",
                timeout: 20000,
                data: _this.imgBase64,
                headers: { "Content-Type": "multipart/form-data" }
            }).then(res => {
                if (res.code === "0000000") {
                    _this.$alert("文件已上传成功，请等待审核!", "文件上传提示", {
                        confirmButtonText: "下一步",
                        type: "warning",
                        callback: () => {
                            _this.$router.replace({name: "opensuccess"});
                        }
                    });
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(() => { });
        }
    }
};
</script>
<style lang="scss">
    .view-upload-file {
        margin-top: 5px;
        padding: 10px 55px;
        .upload-form{
            padding-top: 35px;
            .el-form-item {
                .el-form-item__label {
                    font-size: 16px;
                    .explain{font-size: 14px;}
                }
            }
            .btn-all{
                line-height: 38px;
                position: relative;
                .file{position: absolute;left: 0;top: 0; width: 180px;height: 40px;opacity: 0;filter: alpha(opacify=0);font-size: 0;}
                .btn{
                    width: 180px;
                    margin-right: 17px;
                    display: inline-block;
                    text-align: center;
                    font-size: 16px;
                    border-radius: 3px;
                    cursor: pointer;
                }
                /*.text{display: block;line-height: 30px;}*/
            }
            img {
                width: 240px;
                height: 150px;
                display: inline-block;
                margin-top: 10px;
            }
        }
        .cant-up{
            padding: 20px 0px;
            .cant-info{
                padding: 5px 16px;
                line-height: 24px;
                font-size: 16px;
            }
            .el-button--yellow{margin: 30px 0 0 5px;}
        }
        /*颜色，背景写在css/theme.scss内views style下*/
    }
</style>
